import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

export interface ILicenseKeyPurchaseDialogProps {
    open: boolean;
    onClose: () => void;
}

export default function LicenseKeyPurchaseDialog({ open, onClose }: ILicenseKeyPurchaseDialogProps) {
    const { t } = useTranslation();
    const { organizationId } = useParams<{ organizationId: string }>();
    const navigate = useNavigate();
    const handleConfirm = () => {
        onClose();
        navigate(`/org/${organizationId}/purchase`);
    };

    return (
        <ContentDialog
            open={open}
            onCancel={onClose}
            onClose={onClose}
            onConfirm={handleConfirm}
            confirmButtonText={t('common:license.key.product.title')}
            title={t('common:license.key.empty.title')}
            description={t('common:license.key.empty.description')}></ContentDialog>
    );
}
